import React from 'react'
import { FormComponent } from '../../components/form/DynamicForm'
import { Form, Validators } from '../../components/form/DynamicFormTs'
import Http from '../../Http';

export default class Autorizar extends FormComponent {
  
  componentDidMount() {
    
    this.FormConfig(
      { defaultUrl: 'guia/one', saveUrl: 'guia/autorizar', backUrl: '' },
      new Form([
        Form.Field('text', 'email', 'Correo', '', [Validators.required]),
        Form.Field('password', 'password', 'Contraseña', null, [Validators.required]),
      ], ['Autorizar'], 'Autorizar Guia con Diferente Origen'), this.formData
    )
  }

  onSubmit = async (i, vals) => {
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guia Validada', sbOpen: true, FormData: Form.Reset(this.state.FormData) }, () => {
        this.props.onSave(Res.data);
      });
    }
    else
      this.setState({ loading: false, sbMsg: `Error al guardar: ${Res.errMsg}`, sbOpen: true });
  }
  
  render() {
    return (
      <div>
        <this.FormRender></this.FormRender>
      </div>
    )
  }
}
